import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Pagination, Spin, Table, Select, Button } from "antd";

import { handleError } from "../../../modules/presence/sagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 10;
const { Option } = Select;

const Filter = ({ item, selectedItem, fetchDistinct, onChange, placeholder, token, width }) => {
  const [items, setItems] = useState([]);

  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(item, token);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(client => (
        <Option key={client} value={client}>
          {client}
        </Option>
      ))}
    </Select>
  );
};

const Families = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [selectedFamily, setSelectedFamily] = useState();
  const [selectedBrand, setSelectedBrand] = useState();
  const match = { label: selectedFamily, "brands.label": selectedBrand };
  const fetchFamilies = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/families`,
        {
          match,
          page,
          pageSize: PAGE_SIZE
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data.docs);

      setTotal(result.data.total);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchFamilies();
  }, [page, selectedFamily, selectedBrand]);
  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      render: id => {
        return <span>{id}</span>;
      }
    },
    {
      title: "label",
      dataIndex: "label",
      key: "label",
      render: label => {
        return <span>{label}</span>;
      }
    },
    {
      title: "marques",
      dataIndex: "brands",
      key: "brands",
      render: brands => {
        return <span>{brands.map(brand => brand.label).join(", ")}</span>;
      }
    }
  ];

  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Liste des familles (family)`}</div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Filter
            selectedItem={selectedFamily}
            fetchDistinct={fetchDistinct}
            item={"label"}
            placeholder={"familles"}
            onChange={setSelectedFamily}
            token={token}
            width={400}
          />
          <Filter
            selectedItem={selectedBrand}
            fetchDistinct={fetchDistinct}
            item={"brands.label"}
            placeholder={"marques"}
            onChange={setSelectedBrand}
            token={token}
            width={400}
          />
        </div>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
        <Pagination defaultCurrent={1} total={total} onChange={setPage} />
      </React.Fragment>
    </Container>
  );
};

export default Families;

const fetchDistinct = async (item, token) => {
  return axios
    .post(
      `${baseapi}/families/distincts/${item}`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/containers/metier/referential/Families.js